var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-secondary small help"},[_vm._v(" Need assistance? Reach out to us at "),_c('a',{attrs:{"href":"mailto:support@affinitylearning.ca?subject=Support Request"}},[_vm._v(" support@affinitylearning.ca")]),_vm._v(". ")])
}]

export { render, staticRenderFns }